<template>
<NavBar></NavBar>
  <div class="container">
    <h1 class="text-center">Users</h1>
    <div v-if="loading">Loading...</div>

    <button @click="openForm" class="btn btn-success rounded-2 m-2">Add a new user</button>

    <div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col"><span @click="sort('firstname')">Name</span></th>
            <th scope="col"><span @click="sort('username')">Username</span></th>
            <th scope="col"><span @click="sort('email')">Email</span></th>
            <th scope="col"><span @click="sort('createdAt')">Created</span></th>
            <th scope="col"><span @click="sort('updatedAt')">Modified</span></th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, userId) in users" :key="userId">
            <td>{{ user.fullname }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.createdAt }}</td>
            <td>{{ user.updatedAt }}</td>
            <td>
              <div>
                <span @click="fillForm(user.id)">
                  <span class="fa fa-pen m-1"/>
                </span>
                <span @click="deleteForm(user.id)">
                  <span class="fa fa-trash m-1"/>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="showModal" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">{{ action }} User</slot>
          </div>

          <div class="modal-body">
            <div>
              <input v-model="newUser.firstname" type="text" class="form-control m-2" placeholder="First Name"/>
              <input v-model="newUser.lastname" type="text" class="form-control m-2" placeholder="Last Name"/>
              <input v-model="newUser.username" type="text" class="form-control m-2" placeholder="Username"/>
              <input v-model="newUser.email" type="email" class="form-control m-2" placeholder="Email"/>
              <input v-model="newUser.password" type="password" class="form-control m-2" placeholder="Password"/>
              <input v-model="newUser.confirm_pw" type="password" class="form-control m-2" placeholder="Confirm Password"/>
            </div>
          </div>

          <div class="modal-footer">
           <button @click="clearForm" class="btn btn-error rounded-0">Cancel</button>
           <button @click="submitUser" class="btn btn-success rounded-0">Submit</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import NavBar from './NavBar';

export default {
  name: 'UserApp',
  props: {
    msg: String
  },
  components: {
    NavBar
  },

  data() {
    return {
      loading: true,
      showModal: false,
      action: "Create",
      sortBy: "id",
      sortOrder: false,
      newUser: {
        id: "",
        firstname: "",
        lastname: "",
        username: "",
        email: "",
        password: "",
        confirm_pw: "",
      },
      users: [],
    }
  },
  created() {
  },
  methods: {
    clearForm() {
        this.showModal = false
        this.action = "Create";
        this.newUser.id = "";
        this.newUser.firstname = "";
        this.newUser.lastname = "";
        this.newUser.username = "";
        this.newUser.email = "";
        this.newUser.password = "";
        this.newUser.confirm_pw = "";
    },

    openForm() {
        this.showModal = true
    },

    async fillForm(id) {
      axios
      .get(this.$apiUrl + 'users/' + id)
      .then(response => {
        this.action = "Edit";
        this.newUser.id = response.data.id;
        this.newUser.firstname = response.data.firstname;
        this.newUser.lastname = response.data.lastname;
        this.newUser.username = response.data.username;
        this.newUser.email = response.data.email;
        this.newUser.password = "";
        this.newUser.confirm_pw = "";
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.openForm()
        this.loading = false
        this.getUsers()
      })
    },

    async deleteForm(id) {
      if(confirm("Do you really want to delete this user?")){
        axios
        .delete(this.$apiUrl + 'users/' + id)
        .then(response => {
          console.log(response)
          this.getUsers()
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => {
          this.loading = false
          this.getUsers()
        })
      }
    },

    async submitUser() {
      this.loading = true
      let f = this.newUser;
      if(f.firstname.length === 0 || f.lastname.length === 0 || f.username.length === 0 || f.email.length === 0) {
        alert("Please fill out all fields !")
        this.loading = false

        return;
      }

      if(this.action == 'Create' && (f.password.length === 0 || f.confirm_pw.length === 0)) {
        alert("Password is required !")
        this.loading = false

        return;
      }

      if(f.password != f.confirm_pw) {
        alert("Password must match !")
        this.loading = false

        return;
      }

      const user = {
        firstname: f.firstname,
        lastname: f.lastname,
        username: f.username,
        email: f.email,
        password: f.password,
      }
  
      if(f.email && this.action == 'Create') {
        axios
        .get(this.$apiUrl + 'users/email/' + f.email)
        .then(response => {
          if (response.data.result == 'exist') {
            alert ("Email already exist")
            this.loading = false

            return

          } 
            this.createUser(user)
        })
      }
      
      if (this.newUser.id) this.updateUser(this.newUser.id, user)
    },

    async createUser(user) {
      axios
      .post(this.$apiUrl + 'users', user)
      .then(response => {
        this.users = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
        this.clearForm()
        this.getUsers()
      })
    },

    async updateUser(id, user) {
      axios
      .patch(this.$apiUrl + 'users/' + id, user)
      .then(response => {
        this.users = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false
        this.clearForm()
        this.getUsers()
      })
    },

    async getUsers() {
      this.loading = true
      axios
      .get(this.$apiUrl + `users?sortBy=${this.sortBy}&sortOrder=${(this.sortOrder ? "ASC" : "DESC")}`)
      .then(response => {
        this.users = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
    },

    sort(by) {
      this.sortBy = by
      this.sortOrder = !this.sortOrder
      this.getUsers()
    }
  },

  mounted() {
    this.clearForm()
    this.getUsers()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width:90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  display: block;
  margin-top: 1rem;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
